module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-01.09446543.png";